'use client'

import { useQuery } from '@apollo/client'
import { Button } from '@chain-zen/ui'
import { useRouter } from 'next/navigation'

import { WorkspaceDetailsSection } from '../../../../components/workspace-settings/workspace-details-section'
import { WorkspacePhotoSection } from '../../../../components/workspace-settings/workspace-photo-section'
import { USER_ROUTES } from '../../../../constants/routes'
import { GET_WORKSPACE } from '../../../../data/queries/workspace'
import { useAuth } from '../../../../hooks/use-auth'

/**
 * Carrier workspace details component for onboarding flow
 * Allows carrier users to set up their workspace logo and details
 */
export const CarrierUserWorkspaceDetails = () => {
  const { selectedWorkspace } = useAuth()
  const router = useRouter()

  const { loading, data } = useQuery(GET_WORKSPACE, {
    context: {
      headers: {
        'ws-id': selectedWorkspace?.workspace.id || ''
      }
    },
    fetchPolicy: 'network-only'
  })

  // Handle missing workspace data
  if (!selectedWorkspace) {
    return (
      <div className="min-h-screen py-8 px-4 flex items-center justify-center">
        <div className="text-center">
          <p className="text-gray-600 dark:text-gray-400">
            Workspace data is missing. Please complete the MC/DOT verification step first.
          </p>
        </div>
      </div>
    )
  }

  const workspaceInfo = data?.workspace

  const handleFinish = () => {
    // Navigate to the next step or dashboard
    router.push(USER_ROUTES.SHIPMENTS) // Adjust this route as needed
  }

  if (loading) {
    return (
      <div className="min-h-screen py-8 px-4 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 dark:border-blue-400"></div>
      </div>
    )
  }

  return (
    <div className="min-h-screen py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="text-4xl mb-4">👀</div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-2">Make your workspace recognizable</h1>
          <p className="text-gray-600 dark:text-gray-400">This helps brokers know who you are at a quick glance.</p>
        </div>

        {/* Content */}
        <div className="space-y-6">
          {!!workspaceInfo && (
            <>
              <WorkspacePhotoSection workspaceInfo={workspaceInfo} />
              <WorkspaceDetailsSection workspaceInfo={workspaceInfo} />
            </>
          )}

          <div className="pt-4">
            <Button variant="default" size="lg" onClick={handleFinish} className="w-full">
              Finish
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
